import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { ViewerService } from '../../../case-viewer/neuroglancer-frame/viewer.service'
import { Dialog } from '@angular/cdk/dialog'
import { Observable, Subject, takeUntil } from 'rxjs'
import {
    openCaseManagementDialog,
    openManagementDialog$,
} from '../../utils/case-management-dialog-utils'
import { CaseManagementDialogComponent } from '../../../case-management/case-management-dialog/case-management-dialog.component'
import { JobStatusDialogComponent } from '../../../jobs/job-status-dialog/job-status-dialog.component'
import { Store } from '@ngrx/store'
import { selectUserName } from '../../../state/user/user.selectors'
import { selectHasCaseId, selectIsSharedCase } from '../../../state/case/case.selectors'

import { environment } from '../../../../environments/environment'

@Component({
    selector: 'app-top-bar',
    templateUrl: './top-bar.component.html',
    styleUrls: ['./top-bar.component.scss'],
})
export class TopBarComponent implements OnInit, OnDestroy {
    @Input() showViewerControls: boolean | undefined

    readonly hasCaseId$: Observable<boolean>

    readonly userName$: Observable<string | null> = this.store.select(selectUserName)

    readonly isSharedCase$: Observable<boolean> = this.store.select(selectIsSharedCase)

    private readonly destroy$ = new Subject<void>()

    layoutButtonText: string = 'xy'

    snapshotMode: boolean = false

    constructor(
        readonly viewer: ViewerService,
        private readonly dialog: Dialog,
        private readonly store: Store
    ) {
        this.hasCaseId$ = this.store.select(selectHasCaseId)
        this.switchSnapshotMode = this.switchSnapshotMode.bind(this)
    }

    ngOnInit(): void {
        openManagementDialog$.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.dialog.open(CaseManagementDialogComponent, { autoFocus: 'dialog' })
        })
    }

    ngOnDestroy(): void {
        this.destroy$.next()
        this.destroy$.complete()
    }

    showCaseManagement(): void {
        openCaseManagementDialog()
    }

    goToInfoPage(): void {
        window.open(environment.infoUrl, '_blank')
    }

    showJobStatus(): void {
        this.dialog.open<void>(JobStatusDialogComponent, { autoFocus: 'dialog' })
    }

    startSnapshot(): void {
        this.switchSnapshotMode()
    }

    switchSnapshotMode(): void {
        this.snapshotMode = !this.snapshotMode
    }
}
